
    import "src/shared/components/AppLayout/Sidebar/index.module.scss?farm_css_modules";
    
    export default {"activeMenuItem": `activeMenuItem-eae7e5b0`,"bottomButtons": `bottomButtons-eae7e5b0`,"mainSlideBarContainer": `mainSlideBarContainer-eae7e5b0`,"menu": `menu-eae7e5b0`,"menuItem": `menuItem-eae7e5b0`,"rotatableIcon": `rotatableIcon-eae7e5b0`,"rotateIt": `rotateIt-eae7e5b0`,"searchInput": `searchInput-eae7e5b0`}
    